import PriceHistoryGraph from './PriceHistoryGraph'
export default PriceHistoryGraph
